import {
    PlatformNavbar,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import config from "../../../config";

export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }
) => {

    const {allowedActions} = useVerifiedPermissions()

    const items = getMenuItems()


    const menuItems = items.filter((item) => {
        return allowedActions.includes(item.rbac as string)
    });


    return <PlatformNavbar
        appTitle={config.appTitle}
        menuItems={menuItems}
        mode={mode}
        changeMode={changeMode}
    />

};